module.exports = __webpack_public_path__ + "static/img/IMG_20150307_165601.286e91a9.jpg";